import React, { useState, useEffect, useCallback, useRef } from 'react';
import { FiSearch, FiRefreshCw, FiUsers, FiX } from 'react-icons/fi';
import { faturamentoService, filterDataService } from '../../services/api';

import { BIMultiSelectSearch, BIPagination } from '../common';
import Loading from '../common/Loading';
const MultiSelectSearch = BIMultiSelectSearch;

const filterLabelStyle = {
  fontSize: '0.74rem',
  fontWeight: 700,
  color: '#64748b',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  marginBottom: '6px',
  display: 'flex',
  alignItems: 'center',
  gap: '4px'
};

function Funcionarios() {
  const [search, setSearch] = useState('');
  const [filterBranch, setFilterBranch] = useState('');
  const [filterStatus, setFilterStatus] = useState('1');
  const searchRef = useRef('');
  searchRef.current = search;

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [sortField, setSortField] = useState('nome');
  const [sortOrder, setSortOrder] = useState('asc');

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const renderSortIcon = (field) => {
    if (sortField !== field) return <span style={{ marginLeft: 4, opacity: 0.2, fontSize: 10, userSelect: 'none' }}>▲▼</span>;
    return <span style={{ marginLeft: 4, fontSize: 10, userSelect: 'none' }}>{sortOrder === 'asc' ? '▲' : '▼'}</span>;
  };

  const load = useCallback(async (pageNum = 1, searchTerm = '', branch = '', status = '1', currentPerPage = perPage) => {
    setLoading(true);
    setPage(pageNum);
    try {
      const params = {
        page: pageNum,
        per_page: currentPerPage,
        sort_by: sortField,
        sort_order: sortOrder,
        sort_direction: sortOrder
      };
      if (status !== '' && status !== null && status !== undefined) {
        params.ativo = status;
      }
      if (searchTerm.trim()) params.search = searchTerm.trim();
      if (branch) params.codfilial = branch;
      const res = await faturamentoService.listEmployees(params);
      setRows(res?.data?.employees || []);
      setTotal(res?.data?.total || 0);
    } catch (e) {
      console.error(e);
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [sortField, sortOrder, perPage]);

  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1);
    load(1, search, filterBranch, filterStatus, newPerPage);
  };

  const totalPages = Math.ceil(total / perPage) || 1;

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
    clearTimeout(window._funcSearchTimer);
    window._funcSearchTimer = setTimeout(() => {
      load(1, value, filterBranch, filterStatus);
    }, 300);
  };

  const handleBranchChange = (value) => {
    setFilterBranch(value);
    setPage(1);
    load(1, search, value, filterStatus);
  };

  const handleStatusChange = (value) => {
    setFilterStatus(value);
    setPage(1);
    load(1, search, filterBranch, value);
  };

  const handleClearAllFilters = () => {
    setSearch('');
    setFilterBranch('');
    setFilterStatus('1');
    load(1, '', '', '1');
  };

  const handlePageChange = (newPage) => {
    load(newPage, search, filterBranch, filterStatus);
  };

  useEffect(() => {
    load(1, search, filterBranch, filterStatus);
  }, [load]);

  const formatDate = (date) => {
    if (!date) return '—';
    return new Date(date).toLocaleDateString('pt-BR');
  };

  const hasActiveFilters = Boolean(search || filterBranch || filterStatus !== '1');

  return (
    <div className="container-fluid py-4">
      <div className="mb-4">
        <h2 className="mb-1">Funcionários Winthor</h2>
        <p className="text-muted mb-0">
          Dados de funcionários sincronizados do Oracle (PCEMPR) com permissão de vendas
        </p>
      </div>

      <div className="settings-container">
        <div className="settings-card-wrapper">
          <div className="card-modern shadow-sm-modern" style={{ overflow: 'visible' }}>
            {/* Header: Título e Contador */}
            <div className="card-header-modern bg-transparent border-0 pt-4 px-4 pb-2">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{ width: '46px', height: '46px' }}
                  >
                    <FiUsers size={22} />
                  </div>
                  <div>
                    <h5 className="mb-0 fw-bold text-dark">Lista de funcionários</h5>
                    <p className="mb-0 text-muted small">Busca por nome, matrícula ou filial</p>
                  </div>
                </div>
                {total > 0 && (
                  <span className="badge-modern badge-modern-primary py-2 px-3 fw-semibold">
                    {total} funcionário{total !== 1 ? 's' : ''}
                  </span>
                )}
              </div>
            </div>

            {/* Painel de Filtros 100% Organizados lado a lado */}
            <div className="px-4 py-3" style={{ position: 'relative', zIndex: 30 }}>
              <div
                className="p-3 rounded-3 border"
                style={{
                  backgroundColor: '#f8fafc',
                  borderColor: '#e2e8f0',
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'flex-end',
                  gap: '12px'
                }}
              >
                {/* 1. Buscar */}
                <div style={{ flex: '2 1 260px', minWidth: '220px' }}>
                  <label style={filterLabelStyle}>
                    <FiSearch size={13} />
                    Buscar Funcionário
                  </label>
                  <div style={{ position: 'relative' }}>
                    <FiSearch
                      size={15}
                      style={{
                        position: 'absolute',
                        left: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#94a3b8',
                        pointerEvents: 'none'
                      }}
                    />
                    <input
                      type="text"
                      className="form-control-modern"
                      placeholder="Nome, matrícula ou função…"
                      value={search}
                      onChange={(e) => handleSearchChange(e.target.value)}
                      style={{
                        height: '40px',
                        paddingLeft: '36px',
                        paddingRight: search ? '34px' : '12px',
                        fontSize: '0.84rem',
                        backgroundColor: '#ffffff'
                      }}
                    />
                    {search && (
                      <button
                        type="button"
                        onClick={() => handleSearchChange('')}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'none',
                          border: 'none',
                          color: '#94a3b8',
                          cursor: 'pointer',
                          padding: '2px',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                        title="Limpar busca"
                      >
                        <FiX size={14} />
                      </button>
                    )}
                  </div>
                </div>

                {/* 2. Filial */}
                <div style={{ flex: '1.5 1 220px', minWidth: '180px' }}>
                  <label style={filterLabelStyle}>
                    Filial
                  </label>
                  <MultiSelectSearch
                    label=""
                    placeholder="Todas as filiais…"
                    value={filterBranch}
                    onChange={handleBranchChange}
                    fetchData={filterDataService.getFiliais}
                    badgeColor="#10b981"
                    showCodePrefix
                  />
                </div>

                {/* 3. Status */}
                <div style={{ flex: '1 1 140px', minWidth: '120px' }}>
                  <label style={filterLabelStyle}>
                    Status
                  </label>
                  <select
                    className="form-control-modern"
                    value={filterStatus}
                    onChange={(e) => handleStatusChange(e.target.value)}
                    style={{
                      height: '40px',
                      fontSize: '0.84rem',
                      backgroundColor: '#ffffff',
                      cursor: 'pointer'
                    }}
                  >
                    <option value="1">Ativos</option>
                    <option value="0">Inativos</option>
                    <option value="">Todos</option>
                  </select>
                </div>

                {/* 4. Ações: Limpar e Atualizar lado a lado */}
                <div className="d-flex align-items-center gap-2" style={{ height: '40px' }}>
                  {hasActiveFilters && (
                    <button
                      type="button"
                      className="btn-modern btn-modern-light"
                      onClick={handleClearAllFilters}
                      style={{
                        height: '40px',
                        padding: '0 14px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        fontSize: '0.84rem'
                      }}
                      title="Limpar todos os filtros"
                    >
                      <FiX size={15} />
                      <span>Limpar</span>
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn-modern btn-modern-light"
                    onClick={() => load(page, search, filterBranch, filterStatus)}
                    disabled={loading}
                    style={{
                      height: '40px',
                      width: '40px',
                      padding: 0,
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    title="Atualizar lista"
                  >
                    <FiRefreshCw size={16} className={loading ? 'spin-ico' : ''} />
                  </button>
                </div>
              </div>
            </div>

            {/* Tabela de Funcionários */}
            <div className="card-body-modern p-4 pt-2" style={{ position: 'relative' }}>
              {loading && rows.length > 0 && (
                <Loading.Overlay text="Atualizando funcionários..." size="sm" />
              )}
              {loading && rows.length === 0 ? (
                <Loading
                  text="Carregando funcionários..."
                  subtext="Buscando lista de colaboradores e filiais..."
                />
              ) : rows.length === 0 ? (
                <div className="text-center py-5 text-muted small">Nenhum funcionário encontrado.</div>
              ) : (
                <div className="table-responsive">
                  <table className="table-modern w-100" style={{ minWidth: '600px' }}>
                    <thead>
                      <tr>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('matricula')}>Matrícula{renderSortIcon('matricula')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('nome')}>Nome{renderSortIcon('nome')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('codfilial')}>Filial{renderSortIcon('codfilial')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('funcao')}>Função{renderSortIcon('funcao')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('data_admissao')}>Admissão{renderSortIcon('data_admissao')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('ativo')}>Status{renderSortIcon('ativo')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((emp) => (
                        <tr key={emp.id}>
                          <td className="fw-semibold">{emp.codfunc}</td>
                          <td>{emp.nome}</td>
                          <td>{emp.codfilial || '—'}</td>
                          <td>{emp.funcao || '—'}</td>
                          <td>{formatDate(emp.data_admissao)}</td>
                          <td>
                            <span className={`badge-modern ${emp.ativo ? 'badge-modern-success' : 'badge-modern-danger'}`}>
                              {emp.ativo ? 'Ativo' : 'Inativo'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {/* Paginação */}
              <BIPagination
                page={page}
                perPage={perPage}
                total={total}
                onPageChange={handlePageChange}
                onPerPageChange={handlePerPageChange}
                itemLabel="funcionários"
                perPageOptions={[10, 25, 50, 100, 200]}
              />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .spin-ico { animation: spin-ico 0.8s linear infinite; display: inline-block; }
        @keyframes spin-ico { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}

export default Funcionarios;
